/**
 * MUI Adapter Layer
 * 
 * This file acts as a single point of import for MUI dependencies.
 * When MUI version changes, update imports and types here only.
 * 
 * Benefits:
 * - Single source of truth for MUI imports
 * - Easy to update when MUI versions change
 * - Type safety maintained
 */

// MUI Core imports - Update these when MUI version changes
export { createTheme, ThemeProvider } from "@mui/material/styles";
export { CssBaseline } from "@mui/material";
export type { Theme, ThemeOptions } from "@mui/material/styles";
export type { Components, ComponentNameToClassKey } from "@mui/material/styles";

// Re-export commonly used MUI utilities
export { useTheme } from "@mui/material/styles";
export type { SxProps } from "@mui/material/styles";

export const MUI_VERSION = "7.3.7";
export const MUI_MAJOR_VERSION = parseInt(MUI_VERSION.split('.')[0]);

// In UI components
export const isMUICompatible = () => {
  if (MUI_MAJOR_VERSION >= 7) {
    // Use MUI v7+ APIs
    return true;
  } else {
    // Use older APIs or show warning
    console.warn('MUI version may not be compatible');
    return false;
  }
};
